<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body" style="min-height: 600px;">
          <!-- <h3 class="box-title">Flash View </h3> -->
          <div class="row form-group">
            <div class="col col-md-12">
              <div class="card border border-success">
                <div class="card-header">
                  <div class="row">
                    <div class="col-md-2">
                      <strong class="card-title">Flash View</strong>
                    </div>
                    <div class="col col-md-2" *ngIf="companyName==''">
                      <select name="company" id="company" class="form-control-sm form-control" [(ngModel)]="company"
                              (change)="chngCompId()">
                        <option value="">All</option>
                        <option value="{{pdetails.companyId}}"
                                *ngFor="let pdetails of compData">{{pdetails.companyName}}</option>
                      </select>
                    </div>
                    <div class="col col-md-2">
                      <select name="filefYear" id="filefYear" [(ngModel)]="filefYear"
                              class="form-control-sm form-control">
                        <option value="">Select Year</option>
                        <option value="{{yr}}" *ngFor="let yr of yearfArr">{{yr}}</option>
                      </select>
                    </div>
                    <div class="col col-md-2">
                      <select name="selectMonth" id="selectMonth" [(ngModel)]="selectMonth"
                              class="form-control-sm form-control">
                        <option value="">Please select</option>
                        <option value="January">January</option>
                        <option value="February">February</option>
                        <option value="March">March</option>
                        <option value="April">April</option>
                        <option value="May">May</option>
                        <option value="June">June</option>
                        <option value="July">July</option>
                        <option value="August">August</option>
                        <option value="September">September</option>
                        <option value="October">October</option>
                        <option value="November">November</option>
                        <option value="December">December</option>
                      </select>
                    </div>
                    <div class="col col-md-2">
                      <button type="submit" class="btn btn-primary btn-sm" (click)="searchFile(1)">Search</button>
                    </div>
                  </div>
                </div>
                <!-- <div class="card-body" >
                    <div class="row form-group">
                        <div class="col col-md-3" *ngIf="companyName==''">
                            <label for="dataType" class=" form-control-label">
                                <strong>Insurer</strong>
                            </label>
                             <select name="company" id="company" class="form-control-sm form-control" [(ngModel)]="company" (change)="chngCompId()" >
                                <option  value="">All</option>
                                <option value="{{pdetails.companyId}}" *ngFor="let pdetails of compData">{{pdetails.companyName}}</option>
                            </select>
                        </div>
                        <div class="col col-md-3">
                            <label for="year" class=" form-control-label">
                                <strong>Year</strong>
                            </label>
                            <select name="filefYear" id="filefYear" [(ngModel)]="filefYear" class="form-control-sm form-control">
                                <option  value="">Select Year</option>
                                <option value="{{yr}}" *ngFor="let yr of yearfArr">{{yr}}</option>
                            </select>
                        </div>
                        <div class="col col-md-3">
                            <label for="monthOrQuarter" class=" form-control-label">
                                <strong>Month</strong>
                            </label>
                            <select name="selectMonth" id="selectMonth" [(ngModel)]="selectMonth" class="form-control-sm form-control">
                                <option value="">Please select</option>
                                <option value="January">January</option>
                                <option value="February">February</option>
                                <option value="March">March</option>
                                <option value="April">April</option>
                                <option value="May">May</option>
                                <option value="June">June</option>
                                <option value="July">July</option>
                                <option value="August">August</option>
                                <option value="September">September</option>
                                <option value="October">October</option>
                                <option value="November">November</option>
                                <option value="December">December</option>
                            </select>
                        </div>
                        <div class="col col-md-3">
                          <label for="" class=" form-control-label">
                            &nbsp;
                          </label> <br />
                           <button type="submit" class="btn btn-primary btn-sm" (click)="searchFile(1)" >Search</button>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col col-md-2" *ngIf="companyName==''">
                            <select name="company" id="company" class="form-control-sm form-control" [(ngModel)]="company" (change)="chngCompId()" >
                                <option  value="">All</option>
                                <option value="{{pdetails.companyId}}" *ngFor="let pdetails of compData">{{pdetails.companyName}}</option>
                            </select>
                        </div>
                        <div class="col col-md-2">
                            <select name="fileYear" id="fileYear" [(ngModel)]="fileYear" class="form-control-sm form-control">
                                <option  value="">Select Year</option>
                                <option value="{{yr}}" *ngFor="let yr of yearArr">{{yr}}</option>
                            </select>
                        </div>
                        <div class="col col-md-2">
                            <select name="selectMonth" id="selectMonth" [(ngModel)]="selectMonth" class="form-control-sm form-control">
                                <option value="">Please select</option>
                                <option value="January">January</option>
                                <option value="February">February</option>
                                <option value="March">March</option>
                                <option value="April">April</option>
                                <option value="May">May</option>
                                <option value="June">June</option>
                                <option value="July">July</option>
                                <option value="August">August</option>
                                <option value="September">September</option>
                                <option value="October">October</option>
                                <option value="November">November</option>
                                <option value="December">December</option>
                            </select>
                        </div>
                        <div class="col col-md-4">
                            <button type="submit" class="btn btn-primary btn-sm" (click)="searchFile(1)" >Search</button>
                        </div>
                    </div>
                </div> -->
              </div>
            </div>
          </div>
          <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid"
                 aria-describedby="bootstrap-data-table_info">
            <thead>
            <tr role="row">
              <th *ngIf="companyName==''">Insurer</th>
              <th>Year</th>
              <th>Month</th>
              <th>For the Month</th>
              <th>For the Month (Previous Year)</th>
              <th>Cumulative Upto Month</th>
              <th>Cumulative Upto Month (Previous Year)</th>
              <th *ngIf="companyName!==''">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr role="row" class="odd" *ngFor="let fdata of fileData">
              <td *ngIf="companyName==''">{{ fdata.companyName }}</td>
              <td>
                <span>{{ fdata.year }}</span>
                <!--<select *ngIf="fdata.isEdit" name="fileYear" id="fileYear" [(ngModel)]="fdata.year" class="form-control-sm form-control">
                  <option value="{{yr}}" *ngFor="let yr of yearArr">{{yr}}</option>
                </select>-->
              </td>
              <td>

                <span>{{ fdata.month ? fdata.month : 'N/A'}}</span>
                <!--<select *ngIf="fdata.isEdit" [(ngModel)]="fdata.month" class="form-control-sm form-control">
                  <option value="{{mon}}" *ngFor="let mon of months">{{mon}}</option>
                </select>-->
              </td>
              <td>
                <span *ngIf="!fdata.isEdit">{{fdata.forMonth}}</span>
                <input *ngIf="fdata.isEdit" class="form-control-sm form-control" [(ngModel)]="fdata.forMonth">
              </td>
              <td>
                <span *ngIf="!fdata.isEdit">{{fdata.forMonthPrev}}</span>
                <input *ngIf="fdata.isEdit" class="form-control-sm form-control" [(ngModel)]="fdata.forMonthPrev">
              </td>
              <td>
                <span *ngIf="!fdata.isEdit">{{fdata.uptoMonth}}</span>
                <input *ngIf="fdata.isEdit"  class="form-control-sm form-control" [(ngModel)]="fdata.uptoMonth">
              </td>
              <td>
                <span *ngIf="!fdata.isEdit">{{fdata.uptoMonthPrev}}</span>
                <input *ngIf="fdata.isEdit" class="form-control-sm form-control" [(ngModel)]="fdata.uptoMonthPrev"></td>
              <td>
                <div *ngIf="companyName!==''">
                  <span *ngIf="!fdata.isEditDisable || fdata.isEditPermision == '1'">
                    <button class= "editbutton" style="cursor:pointer;" *ngIf="!fdata.isEdit" (click)="fdata.isEdit = !fdata.isEdit">
                      <i class="fa fa-pencil-square-o" style="font-size: 20px;color: rgb(38, 0, 255);" aria-hidden="true"></i>
                    </button>
                  </span>
                  <button [disabled]="fdata.isEditDisable && fdata.isEditPermision == '0'" style="cursor:pointer;" *ngIf="fdata.isEdit" (click)="saveEditedData(fdata)">
                    <i class="fa fa-floppy-o" style="font-size: 20px;color: rgb(255, 0, 0);" aria-hidden="true"></i>
                  </button>
                  <button title="Edit request" *ngIf="fdata.isEditDisable && fdata.isEditPermision == '0' && fdata.editReq === '0'" style="cursor:pointer;margin-left: 10px;" (click)="reqEditFlashUpload(fdata)">
                    <i class="fa fa-recycle" style="font-size: 20px;color: red;" aria-hidden="true"></i>
                  </button>
                  <span *ngIf="fdata.editReq === '1'" style="color: #0067d6; font-weight: bold;">Requested</span>
                </div>
                <!-- <div *ngIf="companyName=='' && fdata.editReq === '1'">
                  <button style="cursor:pointer;" title="Approve" (click)="givePermission('1', fdata)">
                    <i class="fa fa-check" style="font-size: 20px;color: blue;" aria-hidden="true"></i>
                  </button>
                  <button style="cursor:pointer;margin-left: 5px" title="Reject" (click)="givePermission('0', fdata)">
                    <i class="fa fa-times" style="font-size: 20px;color: red;" aria-hidden="true"></i>
                  </button>
                </div> -->
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" id="bootstrap-data-table_info" role="status" aria-live="polite">
            Showing {{(curPage - 1) * perPageRow + 1}} to {{(curPage - 1) * perPageRow + noOfRows}} of {{totalRows}}
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="dataTables_paginate paging_simple_numbers" id="bootstrap-data-table_paginate">
            <ul class="pagination">
              <!-- <li class="paginate_button page-item previous disabled" id="bootstrap-data-table_previous" (click)="searchFile(curPage-1)" *ngIf="curPage==1">
                   <a  aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
               </li>-->

              <li class="paginate_button page-item {{item==curPage?'active':''}}"
                  *ngFor="let item of pages; let i = index" (click)="searchFile(item)">
                <a aria-controls="bootstrap-data-table" class="page-link">{{item}}</a>
              </li>
              <!--<li class="paginate_button page-item next" id="bootstrap-data-table_next" (click)="searchFile(curPage-1)" >
                  <a  aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0" class="page-link">Next</a>
              </li>-->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div><!-- .animated -->

